/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SemanticDomain } from "./semantic-domain";

/**
 *
 * @export
 * @interface SemanticDomainUserCount
 */
export interface SemanticDomainUserCount {
  /**
   *
   * @type {string}
   * @memberof SemanticDomainUserCount
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainUserCount
   */
  username?: string | null;
  /**
   *
   * @type {Set<string>}
   * @memberof SemanticDomainUserCount
   */
  domainSet: Set<string>;
  /**
   *
   * @type {number}
   * @memberof SemanticDomainUserCount
   */
  domainCount?: number;
  /**
   *
   * @type {number}
   * @memberof SemanticDomainUserCount
   */
  wordCount?: number;
  /**
   *
   * @type {SemanticDomain}
   * @memberof SemanticDomainUserCount
   */
  recentDomain?: SemanticDomain;
}
